import React from 'react';
import {
    IconButton,
    Tooltip
} from 'material-ui';
import AcceptIcon from 'material-ui-icons/CheckCircle';
import CancelIcon from 'material-ui-icons/HighlightOff';

class LabelTranslationsTableItemActionEdit extends React.Component {

    render() {
        const {
            classes,
            label,
            labelTranslation,
            labelTranslationBySite,
            createLabelTranslation,
            updateLabelTranslation,
            cancelUpdateLabelTranslation
        } = this.props;

        return (
            <span className={classes.tableIconBtn}>
                <Tooltip title="Save Translation">
                    <IconButton 
                        className="smallIconButton editColor" 
                        onClick={(e) => {
                            if (labelTranslation === null) {
                                createLabelTranslation(labelTranslationBySite, label.id);
                            }
                            if (labelTranslation !== null) {
                                updateLabelTranslation(labelTranslationBySite, label.id);
                            }
                        }}
                    >
                        <AcceptIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Discard changes">
                    <IconButton className="smallIconButton disableColor" onClick={cancelUpdateLabelTranslation}>
                        <CancelIcon />
                    </IconButton>
                </Tooltip>
            </span>
        )
    }
};

export default LabelTranslationsTableItemActionEdit;




// WEBPACK FOOTER //
// ./src/containers/labels/translations/LabelTranslationsTableItemActionEdit.jsx